export default "__VITE_ASSET__Cvw98dls__"